<script>
    import { createEventDispatcher } from 'svelte';
  import SVGImage from "./SVGImage.svelte";
  import lock from "../assets/icons/lock.svg";

  export let active;

  const dispatch = createEventDispatcher();


  function play() {
    if (!active) {
        return;
    }
    dispatch('play');
	}

</script>

<div class="bg-zinc-700 rounded-lg m-4 mx-4 p-4">
  <div class="grid grid-cols-2 py-3">
    <!-- First Column -->
    <div class="flex gap-5 items-center">
      <div class="space-y-2">
        <h3 class="text-lg font-semibold text-white-100 leading-none tracking-wide">Acceso completo</h3>
      </div>
    </div>

    <!-- Second Column with Play Button -->
    <div class="flex items-center justify-end">
      {#if active}
        <button on:click={() => play()} class="bg-zinc-800 text-white rounded-md px-4 py-2 hover:bg-zinc-600">Obtener</button>
      {:else}
        <div class="relative w-12 h-12 overflow-hidden flex justify-center items-center shrink-0">
          <SVGImage imagePath="{lock}" />
        </div>
      {/if}
    </div>
  </div>
</div>
